export enum ELanguage {
  GB = 'gb',
  DE = 'de',
  RS = 'rs',
}
